export default function Experience() {
  return (
    <section id="experiencia" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="mb-16">
          <div className="inline-block px-4 py-2 bg-navy/10 rounded-full mb-6">
            <span className="text-navy text-sm font-semibold uppercase tracking-wide">Trayectoria</span>
          </div>
          <h2 className="font-serif font-extrabold text-5xl lg:text-6xl text-gray-900 leading-tight max-w-3xl">
            Una Década Sirviendo a la Justicia
          </h2>
        </div>

        {/* Experience Card */}
        <div className="bg-gray-900 rounded-3xl p-8 lg:p-16 w-full lg:w-[90%] mx-auto">
          <div className="grid lg:grid-cols-5 gap-12 items-center">
            {/* Left Content */}
            <div className="lg:col-span-3">
              <div className="inline-block px-3 py-1 bg-gold/20 rounded-full mb-4">
                <span className="text-gold text-xs font-semibold uppercase tracking-wide">Poder Judicial</span>
              </div>
              <h3 className="font-serif font-bold text-3xl lg:text-4xl text-white mb-6">
                Ex Fiscal del Ministerio Público
              </h3>
              <p className="text-gray-300 text-base lg:text-lg leading-relaxed mb-8">
                Experiencia directa en investigación criminal, acusación penal y representación del Estado en procesos judiciales de alta complejidad. Especialización en delitos económicos, corrupción y crimen organizado.
              </p>

              {/* Achievements */}
              <ul className="space-y-4">
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-gold rounded-full mt-2 flex-shrink-0"></div>
                  <span className="text-gray-300 text-base">Tasa de éxito del 87% en casos penales</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-gold rounded-full mt-2 flex-shrink-0"></div>
                  <span className="text-gray-300 text-base">Coordinación de equipos multidisciplinarios</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-gold rounded-full mt-2 flex-shrink-0"></div>
                  <span className="text-gray-300 text-base">Reconocimientos por excelencia profesional</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-gold rounded-full mt-2 flex-shrink-0"></div>
                  <span className="text-gray-300 text-base">Participación en casos de alto perfil nacional</span>
                </li>
              </ul>
            </div>

            {/* Right Image */}
            <div className="lg:col-span-2">
              <div className="w-full h-[400px] rounded-2xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/a14073ee7137e05e908b9b7fa30988ce.jpg"
                  alt="Emblema Judicial"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Timeline */}
        <div className="mt-20 max-w-4xl mx-auto">
          <div className="space-y-12">
            {/* Timeline Item 1 */}
            <div className="flex gap-8">
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 rounded-full bg-gold flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-sm">1</span>
                </div>
                <div className="w-0.5 h-full bg-gray-200 mt-4"></div>
              </div>
              <div className="pb-12">
                <div className="text-gold font-semibold text-sm mb-2">2015 - 2025</div>
                <h4 className="font-serif font-bold text-xl text-gray-900 mb-2">Fiscal en el Ministerio Público</h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Investigación y acusación en casos penales complejos, incluyendo delitos económicos, corrupción y crimen organizado.
                </p>
              </div>
            </div>

            {/* Timeline Item 2 */}
            <div className="flex gap-8">
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 rounded-full bg-gold flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-sm">2</span>
                </div>
                <div className="w-0.5 h-full bg-gray-200 mt-4"></div>
              </div>
              <div className="pb-12">
                <div className="text-gold font-semibold text-sm mb-2">2012 - 2025</div>
                <h4 className="font-serif font-bold text-xl text-gray-900 mb-2">Formación Especializada</h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  En mi labor, trabajé en fiscalías especializadas, como Fiscalía Adjunta de Probidad, Transparencia y Anticorrupción, Fiscalía Adjunta de Fraudes, Fiscalía Adjunta de Delitos Económicos, Fiscalía de Género, Fiscalía de Flagrancias, así como el trámite en Fiscalías de Trámite Ordinario.
                </p>
              </div>
            </div>

            {/* Timeline Item 3 */}
            <div className="flex gap-8">
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 rounded-full bg-gold flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-sm">3</span>
                </div>
              </div>
              <div>
                <div className="text-gold font-semibold text-sm mb-2">2025 - Actualidad</div>
                <h4 className="font-serif font-bold text-xl text-gray-900 mb-2">Práctica Privada</h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Defensa legal especializada, asesoría jurídica y representación en litigios complejos.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
